/**
 * Grow With Us — Social CTA injector
 *
 * Injects a brand-controlled heading, copy block, and social icon row
 * into #Instafeed-content-placeholder. Designed as a static fallback
 * for the Instafeed widget area.
 *
 * Performance:
 *   • IIFE — no globals
 *   • Single innerHTML write — one reflow
 *   • Icons lazy-loaded and async-decoded
 *
 * Accessibility (WCAG 2.2):
 *   • Each link has a unique aria-label
 *   • 44×44 touch targets (2.5.8 AAA)
 *   • Visible :focus-visible outline (styled in companion CSS)
 *   • Decorative <img alt=""> — label is on the <a>
 *   • role="list" preserves semantics if browser CSS strips it
 */
(function () {
  'use strict';

  const TARGET_ID = 'Instafeed-content-placeholder';

  /* Update these URLs with the brand's actual social profiles */
  const SOCIALS = [
    {
      name: 'Instagram',
      url:  'https://www.instagram.com/omibynaomi/',
      icon: 'https://cdn.shopify.com/s/files/1/0267/3537/8613/files/index-instagram-icon-instagram.svg?v=1778844909'
    },
    {
      name: 'Facebook',
      url:  'https://www.facebook.com/omibynaomi',
      icon: 'https://cdn.shopify.com/s/files/1/0267/3537/8613/files/index-instagram-icon-facebook.svg?v=1778844909'
    }
  ];

  function buildMarkup() {
    const items = SOCIALS.map((s) => `
      <li>
        <a class="grow-with-us__social-link"
           href="${s.url}"
           target="_blank"
           rel="noopener noreferrer"
           aria-label="Follow us on ${s.name}">
          <img src="${s.icon}"
               alt=""
               width="44"
               height="44"
               loading="lazy"
               decoding="async">
        </a>
      </li>
    `).join('');

    return `
      <div class="grow-with-us flex flex-col gap-4">
        <h2 class="grow-with-us__heading">Grow with us</h2>
        <p class="grow-with-us__copy">Follow us on social and read the journal for daily tips on how to achieve your thickest, strongest, most beautiful hair.</p>
        <ul class="grow-with-us__socials flex items-center" role="list">
          ${items}
        </ul>
      </div>
    `;
  }

  function init() {
    const target = document.getElementById(TARGET_ID);
    if (!target) return;

    const wrapper = target.closest('.shopify-block');
    if (wrapper) wrapper.classList.add('instafeed-content-wrapper');

    target.innerHTML = buildMarkup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();